<template>
  <div class="card">
    <div
        v-if="showLieuDeLivraison"
        class="card-content columns is-marginless is-vcentered">
          <selection-lieu-de-livraison
              :lieuDeLivraison="ordreTravail.otStock.lieuDeLivraison"
              v-model="nomLieuDeLivraison"
              @select="selectLieuDeLivraison"
              class="column is-5  is-paddingless">
          </selection-lieu-de-livraison>
          <div class="column is-narrow mgl-10px mgt-30px  is-paddingless"
              v-if="ordreTravail.otStock.lieuDeLivraisonId"
              @click="deleteLieuDeLivraison()">
              <b-icon icon="delete-forever" type="is-danger" class="is-cursor-pointer">
              </b-icon>
          </div>
    </div>
  </div>
</template>

<script>
import selectionLieuDeLivraison from '@/components/commun/fournisseur/lieuDeLivraison/selectionLieuDeLivraison';
import { createNamespacedHelpers } from 'vuex';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';

const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    ordreTravail: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      nomLieuDeLivraison: '',
    };
  },
  components: {
    selectionLieuDeLivraison,
  },
  computed: {
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    moduleStockTiersActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleStockTiers.key);
    },
    moduleImpressionActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.demandeImpression.key);
    },
    showLieuDeLivraison() {
      return this.moduleImpressionActive
          && this.moduleStockTiersActive
          && this.ordreTravail
          && this.ordreTravail.otStock;
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    deleteLieuDeLivraison() {
      this.ordreTravail.otStock.lieuDeLivraisonId = null;
      this.nomLieuDeLivraison = '';
    },
    selectLieuDeLivraison(lieu) {
      this.ordreTravail.otStock.lieuDeLivraisonId = lieu?.id;
    },
  },
  async mounted() {
    await this.loadParametresInterne([
      PARAMETRES_INTERNE_KEYS.moduleStockTiers.key,
      PARAMETRES_INTERNE_KEYS.demandeImpression.key,
    ]);
  },
};
</script>
